import i18n from "@/i18n";
import { ToastOptions } from "@/types";
import { format as formatD } from "date-fns";
import { toast } from "sonner";

// #region getUserLanguage
export function getUserLanguage() {
  const lang = localStorage.getItem("i18nextLng") || "en";
  return lang;
}
// #endregion getUserLanguage

// #region setUserLanguage
export function setUserLanguage(iso_code: string) {
  localStorage.setItem("i18nextLng", iso_code);
}
// #endregion setUserLanguage

// #region systemErrorAlertText
export function systemErrorAlertText(): string {
  let htmlContent = "";
  htmlContent += `<div class="mt-5">${i18n.t("If you're encountering any issues, we're here to help!")}</div>`;
  htmlContent += `<div class="mt-2">${i18n.t("Please don't hesitate to contact us directly at")} <a class="text-secondary" href="mailto:${getSupportEmail()}">${getSupportEmail()}</a>.</div>`;

  return htmlContent;
}
// #endregion systemErrorAlertText

// #region getSupportEmail
export function getSupportEmail(): string {
  return import.meta.env.VITE_PROJECT_SUPPORT_EMAIL || "";
}
// #endregion getSupportEmail

export function getAlertTypeString(alertType: string): string {
  // TODO: Change per client requirements
  switch (alertType) {
    default:
      return i18n.t("Unknown Alert Type");
  }
}

export function formatDate(
  date: string | number | Date | null | undefined,
  includeTime: boolean = false
): string {
  if (!date) {
    return "";
  }

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return "";
  }

  const dateFormat = includeTime ? "yyyy/MM/dd HH:mm" : "yyyy/MM/dd";
  return formatD(parsedDate, dateFormat);
}

export function getBuildDate(): Date | null {
  // get the build date from meta tag
  // <meta name="build-date" content="2025-01-15T06:20:16.027Z" />
  const el = document.querySelector('meta[name="build-date"]');
  if (!el) return null;
  const date = el.getAttribute("content");
  if (!date) return null;
  return new Date(date);
}

//VITE_INCLUDE_LANGUAGE_SUPPORT
export function isLanguageSupportEnabled(): boolean {
  const langBool = import.meta.env.VITE_INCLUDE_LANGUAGE_SUPPORT;
  if (langBool === "true") return true;
  return false;
}

// #region Toasts
// Error
export function genericFailureToast(
  message: string,

  position?:
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right"
    | "top-center"
    | "bottom-center",
  actionLabel?: string,
  callback?: () => void
): void {
  toast.error("Error", {
    description: message,
    duration: 3000,
    position: position ?? undefined,
    ...(callback && {
      action: {
        label: actionLabel ?? "",
        onClick: callback,
      },
    }),
  });
}

// Success
export function genericSuccessToast(
  message: string,
  options?: ToastOptions
): void {
  toast.success("Success", {
    description: message,
    duration: options?.duration ?? 3000,
    position: options?.position ?? undefined,
    ...(options?.callback && {
      action: {
        label: options?.actionLabel ?? "",
        onClick: options?.callback,
      },
    }),
  });
}

// #endregion Toasts

// #region copyToClipboard
export function copyToClipboard(text: string) {
  // copy the markdown content to clipboard
  try {
    navigator.clipboard.writeText(text).then(() => {
      genericSuccessToast(i18n.t("Copied to clipboard"));
    });
  } catch (error) {
    console.error("Failed to copy:", error);
    genericFailureToast(i18n.t("Failed to copy"));
  }
}
// #endregion copyToClipboard
